// extracted by mini-css-extract-plugin
export default {"tagGroup":"tag_group_tagGroup__dSF+v","tag":"tag_group_tag__hf2AV","tagInput":"tag_group_tagInput__6doTx"};